import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Box, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import ValueChangeTopGainersCard from "./ValueChangeTopGainersCard";
import MarketWatchTopGainersTitle from "../../MarketWatchTopGainersTitle";
import MarketWatchTopGainersSkeleton from "../../MarketWatchTopGainersSkeleton";
import NotFound from "../../../../components/notfound/NotFound";

const breakpoints = {
  600: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  900: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  1200: {
    slidesPerView: 4,
    spaceBetween: 10,
  },
  1536: {
    slidesPerView: 5,
    spaceBetween: 10,
  },
};

export default function ValueChangeTopGainers({
  title,
  data,
  isLoading,
  url,
  unit,
}) {
  return (
    <Paper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <MarketWatchTopGainersTitle title={title} url={url} />
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          navigation
          breakpoints={breakpoints}
          modules={[Navigation]}
          className="mySwiper"
        >
          {!isLoading ? (
            data.length > 0 ? (
              data?.map((item, i) => (
                <SwiperSlide key={i}>
                  <Link to={item.links[0].link} target="_blank">
                    <ValueChangeTopGainersCard chartData={item} unit={unit} />
                  </Link>
                </SwiperSlide>
              ))
            ) : (
              <Box sx={{ height: "245px" }}>
                <NotFound />
              </Box>
            )
          ) : (
            <MarketWatchTopGainersSkeleton />
          )}
        </Swiper>
      </Box>
    </Paper>
  );
}
